import { render, staticRenderFns } from "./CustomerCountry.vue?vue&type=template&id=bff4e076&"
import script from "./CustomerCountry.vue?vue&type=script&lang=js&"
export * from "./CustomerCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports